import { connect } from 'react-redux';
import SignUpForm from './SignUpForm';

import { registerUser } from '../../actions/currentUserAction';

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
});
const mapDispachToProps = (dispatch) => ({
  onRegister: (username, mail, firstName, lastName, password) =>
    dispatch(
      registerUser({
        username,
        mail,
        firstName,
        lastName,
        password,
      }),
    ),
});

export default connect(mapStateToProps, mapDispachToProps)(SignUpForm);
